export default __webpack_public_path__ + "static/media/icon_steamer_1.8f5c31e9.svg";